
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M6 13.5a1.5 1.5 0 113.001.001A1.5 1.5 0 016 13.5zm0-6a1.5 1.5 0 113.001.001A1.5 1.5 0 016 7.5zm0-6a1.5 1.5 0 113.001.001A1.5 1.5 0 016 1.5z","opacity":".2"}})])
          )
        }
      }
    